import { useEffect, useState, useRef } from "react";
import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.min.css";
import NavButton from "../homepage/header-banner/TopNavButton";
import Footer from "../homepage/footer/Footer";
import "./assets/css/style-page-modal.css";

function AICallPlus() {
    const [remoteHtml, setRemoteHtml] = useState("");
    
    useEffect(() => {
        const remoteUrl = "https://hanbiro.com/software/ai-call-plus-content-test.html";
        let mounted = true;
        const injectedHeadStyles = []; 

        fetch(remoteUrl)
            .then((res) => res.text())
            .then((html) => {
                if (!mounted) return;

                const parser = new DOMParser();
                const doc = parser.parseFromString(html, "text/html");

                const styleNodes = Array.from(doc.querySelectorAll("style"));
                styleNodes.forEach((s, idx) => {
                    const txt = s.textContent || "";
                    const fixed = txt.replace(
                        /url\((?:['"])?(?!https?:|\/\/)([^'")]+)(?:['"])?\)/g,
                        (_, relPath) => {
                            try {
                                return `url(${new URL(relPath, remoteUrl).href})`;
                            } catch (e) {
                                return `url(${relPath})`;
                            }
                        }
                    );

                    const marker = `data-remote-style="${remoteUrl}#${idx}"`;
                    if (!document.head.querySelector(`style[${marker}]`)) {
                        const st = document.createElement("style");
                        st.setAttribute("data-remote-style", `${remoteUrl}#${idx}`);
                        st.textContent = fixed;
                        document.head.appendChild(st);
                        injectedHeadStyles.push(st);
                    }
                });

                const contentEl =
                    doc.querySelector("#container") ||
                    doc.querySelector(".wrap") ||
                    doc.querySelector(".sub-wrap") ||
                    doc.querySelector("main") ||
                    doc.querySelector("body");

                const extractedNode = contentEl ? contentEl.cloneNode(true) : doc.body.cloneNode(true);

                extractedNode.querySelectorAll && extractedNode.querySelectorAll("style").forEach(n => n.remove());

                Array.from(extractedNode.querySelectorAll("[src], [href]")).forEach((el) => {
                    ["src", "href"].forEach((attr) => {
                        const v = el.getAttribute && el.getAttribute(attr);
                        if (v && !v.match(/^(https?:|\/\/|#)/i)) {
                            try {
                                el.setAttribute(attr, new URL(v, remoteUrl).href);
                            } catch (e) {
                                // ignore
                            }
                        }
                    });
                });

                ["header", ".header", ".top-bar", "footer", ".footer"].forEach((sel) => {
                    extractedNode.querySelectorAll && extractedNode.querySelectorAll(sel).forEach(n => n.remove());
                });

                setRemoteHtml(extractedNode.innerHTML);
            })
            .catch((error) => {
                console.error("Error fetching remote HTML:", error);
                if (mounted) setRemoteHtml("<p>Error loading content.</p>");
            });

        return () => {
            mounted = false;
            injectedHeadStyles.forEach(st => st.parentNode && st.parentNode.removeChild(st));
        };
    }, []);

    return (
        <div className="pageaicallpluscontent">
            <NavButton
                lang="ko"
                option={{
                    logo: "https://hanbiro.com/cloud/library/banner/hanbiro.svg",
                    link: "https://hanbiro.com/",
                    color: { backgroundColor: "#7061FF" },
                    itemNavClass: "item-nav nav-pur",
                    menuListProduct: "menu-list-product-item",
                    menuListVora: "vora",
                    menuListGroupware: "groupware",
                    titleTab: "mb-3",
                }}
            />

            <div
                className="remote-content"
                dangerouslySetInnerHTML={{ __html: remoteHtml }}
            ></div>

            <Footer
                option={{
                    textColor: "text-color external-link text-pur-color",
                    textlinkColor: "text-color text-pur-color",
                }}
            />
        </div>
    );
}

export default AICallPlus;
